import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { AuthUser } from '~/features/auth/types/auth.type';

/**
 * 현재 로그인한 관리자 정보 조회
 * @description Bearer 토큰 인증 필요
 * @endpoint GET /admin/auth/me
 * @returns 현재 로그인한 관리자 정보
 */
export function getMeApi() {
  return axiosInstance.get<ApiResponse<AuthUser>>('/admin/auth/me');
}
